import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {amplitude} from '../../../../services/amplitude';
import cryptoService from '../../../../services/cryptoService';
import {makeSelectAmplitudeModelName, selectDeviceSerialNumber} from '../../../../state/selectors/iotDevice';

const useAmplitudeIqosProps = () => {
    const deviceSerialNumber = useSelector(selectDeviceSerialNumber);
    const modelName = useSelector(makeSelectAmplitudeModelName());

    useEffect(() => {
        if (!deviceSerialNumber) return;

        const hashedDeviceSerialNumber = cryptoService.hashMD5(deviceSerialNumber);

        amplitude.setIqosDeviceId(hashedDeviceSerialNumber);
    }, [deviceSerialNumber]);

    useEffect(() => {
        if (!modelName) return;

        amplitude.setIqosModelName(modelName);
    }, [modelName]);
};

export default useAmplitudeIqosProps;
